import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import {
  ExameAsoDtoCreate,
  ExameAsoDtoUpdate,
  ExameAsoView,
  ExamesClienteQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const EXAMES_URL = `${API_URL}/empresas/cliente/exame`

/**
 * Busca todos os exames um cliente
 * @param idEmpresa Identificador da empresa pai
 * @param query string
 * @returns ExameAsoView
 */
export const getExamesCliente = (
  idEmpresa: ID,
  query: string
): Promise<ExamesClienteQueryResponse> => {
  return axios
    .get(`${EXAMES_URL}?idEmpresa=${idEmpresa}&${query}`)
    .then((d: AxiosResponse<ExamesClienteQueryResponse>) => d.data)
}

/**
 * Busca um exame
 * @param idExame Identificador do exame
 * @returns ExameAsoView
 */
export const getExameClienteById = (idExame: ID): Promise<ExameAsoView | undefined> => {
  return axios
    .get(`${EXAMES_URL}/${idExame}`)
    .then((response: AxiosResponse<ExameAsoView>) => response.data)
}

/**
 * Cadastra um exame de um cliente
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param exame ExameAsoDtoCreate
 * @returns ExameAsoView
 */
export const createExameCliente = (
  idEmpresaCliente: ID,
  exame: ExameAsoDtoCreate
): Promise<ExameAsoView> => {
  return axios
    .post(`${EXAMES_URL}/${idEmpresaCliente}`, exame)
    .then((resp: AxiosResponse<ExameAsoView>) => resp.data)
}

/**
 * Altera um exame de um cliente
 * @param idExame Identificador do exame
 * @param exame ExameAsoDtoUpdate
 * @returns ExameAsoView
 */
export const editExameCliente = (idExame: ID, exame: ExameAsoDtoUpdate): Promise<ExameAsoView> => {
  return axios
    .put(`${EXAMES_URL}/${idExame}`, exame)
    .then((resp: AxiosResponse<ExameAsoView>) => resp.data)
}

/**
 * Excluir um exame de um cliente
 * @param idExame Identificador do exame
 * @returns void
 */
export const deleteExameCliente = (idExame: ID): Promise<void> => {
  return axios.delete(`${EXAMES_URL}/${idExame}`).then(() => {})
}

/**
 * Excluir exames em lote. O backend não tem exclusão em lote: dispara uma requisição por id,
 * em paralelo, e rejeita se qualquer uma falhar.
 * @param examesIds Identificadores dos exames
 */
export const deleteLoteExamesCliente = (examesIds: Array<ID>): Promise<void> => {
  return Promise.all(examesIds.map(deleteExameCliente)).then(() => {})
}
